<template>

    <div class="admin-progress-monitor-collection-methods"
         v-if="config.behaviorReport">

        <draggable class="dragArea"
                   v-model="config.behaviorReport.responseFormats">
            <b-row v-for="(method, index) in config.progressMonitor.collectionMethods">
                <b-col>
                    <b-card no-body class="mb-3">
                        <b-card-header v-b-toggle="`method_${index}`">

                            <open-icon name="resize-height" class="drag-handle"></open-icon>
                            <open-icon name="chevron-bottom" v-if="method.visible"></open-icon>
                            <open-icon name="chevron-right" v-if="!method.visible"></open-icon>

                            {{ method.title }}

                            <div class="float-right">
                                <b-form-checkbox v-model="method.enabled" class="d-inline mr-3">
                                    Enabled
                                </b-form-checkbox>

                                <b-btn variant="default" size="sm"
                                       @click="deleteMethod(method)">
                                    <open-icon name="delete"></open-icon>
                                </b-btn>
                            </div>

                        </b-card-header>
                        <b-collapse :id="`method_${index}`"
                                    v-model="method.visible">
                            <b-card-body>

                                <b-form-group label="Title">
                                    <b-form-input v-model="method.title"></b-form-input>
                                </b-form-group>

                                <b-form-group label="Description">
                                    <VueTrix v-model="method.template"/>
                                </b-form-group>


                                <b-card header="Formats">
                                    <draggable class="dragArea"
                                               v-model="method.formats">
                                        <b-row class="mb-4"
                                               v-for="format in method.formats">
                                            <b-col cols="1">
                                                <open-icon name="resize-height" class="drag-handle"></open-icon>
                                            </b-col>
                                            <b-col>
                                                <b-form inline>
                                                    <label class="mr-2">Title</label>
                                                    <b-form-input class="maxi-input"
                                                                  v-model="format.title"></b-form-input>
                                                    <label class="mx-2">Min</label>
                                                    <b-form-input type="number" class="mini-input"
                                                                  v-model="format.min"></b-form-input>
                                                </b-form>
                                                <b-form inline class="mt-2">
                                                    <label class="mr-2">Alias</label>
                                                    <b-form-input class="maxi-input"
                                                                  v-model="format.alias"></b-form-input>
                                                    <label class="mx-2">Max</label>
                                                    <b-form-input type="number" class="mini-input"
                                                                  v-model="format.max"></b-form-input>
                                                </b-form>
                                            </b-col>
                                            <b-col cols="1">
                                                <b-btn variant="default" size="sm"
                                                       @click="deleteFormat(method, format)">
                                                    <open-icon name="delete"></open-icon>
                                                </b-btn>
                                            </b-col>
                                        </b-row>
                                    </draggable>

                                    <b-btn variant="success" size="sm" class="float-right"
                                           @click="addFormat(method)">
                                        Add Format
                                    </b-btn>
                                    <div class="clearfix"></div>

                                </b-card>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>

            </b-row>
        </draggable>

        <b-btn variant="success" class="float-right"
               @click="addMethod()">
            Add Collection Method
        </b-btn>

        <div class="clearfix"></div>

    </div>

</template>

<script>

    import Vue from 'vue'
    import draggable from 'vuedraggable'

    export default Vue.extend({
        name: 'AdminProgressMonitorCollectionMethods',
        components: {
            draggable
        },
        computed: {
            config() {
                return this.$store.state.config
            }
        },
        methods: {
            addMethod() {
                this.config.progressMonitor.collectionMethods.push(
                    {title: 'New Method', options: []}
                )
            },
            deleteMethod(method) {
                if (confirm('Permanently delete this Collection Method?')) {
                    this.config.progressMonitor.collectionMethods = _.without(this.config.progressMonitor.collectionMethods, method)
                }
            },
            addFormat(method) {
                method.formats.push({label: '', value: method.formats.length + 1})
            },
            deleteFormat(method, f) {
                method.formats = _.without(method.formats, f)
            }
        },
    })
</script>

<style lang="scss">
    .mini-input {
        max-width: 75px;
    }
    .maxi-input {
        min-width: 400px;
    }
</style>